import React from 'react';
import {Helmet} from "react-helmet";
import { Container } from '@mui/material';
//import logo from '../../assets/images/logo_new.png';
//import arrow_down from "../../assets/images/arrow-down-01.png";
import rent_success from "./assets/rent-success-logo.svg";
//import success_purple from "../../assets/images/success_purple.png";
//import { Link } from 'react-router-dom';
import Rentsuccessanimation from './Rentsuccessanimation';
import RentHeader from '../RentHeader/RentHeader';
import RentSuccessPage from './RentSuccessPage/RentSuccessPage';
// import PopularTopics from '../Rentid2/PopularTopics/PopularTopics';
import Footer from '../Footer/Footer';
import BetaForm from '../BetaForm';
const RentSuccess2 = () => {


  return (
  <>
      <Helmet>
        <title>RentSuccess | Digital Back Office Success Center</title>
        <meta property="og:title" content="Rent Success | Digital Back Office Success Center"/>
        <meta name="twitter:title" content="Rent Success | Digital Back Office Success Center" />
        <meta name="description" content="Simplify operations, maximize revenue, and streamline your rental business with Rent Success. From refunds and claims management to customizable policies and technical support, we're here to empower your rental success." />
        <meta name="twitter:description" content="Achieve rental success with Rentid's back-office tools. Streamline refunds, claims, cancellations, and more while empowering your business operations." />
        <meta property="og:description" content="Empowering your rental journey with tools for seamless operations—refunds, claims, guest reporting, customizable policies, and on-rent guidelines. Simplify success with Rentid." />
        <meta name="keywords" content="Rent Success, Digital Back Office, Car Rental Support, Refund Policies, Insurance Claims Management, Cancellation Policies, Administrative Support, Guest Reporting, Rentid Resource Center, Rental Empowerment, Rental Guidelines" />
        <meta property="og:url" content="https://www.rentid.io/rentsuccess" />
        <link rel="canonical" href="https://www.rentid.io/rentsuccess" />
      </Helmet>
      <div className="bannerRentSuccessTopMain">
        <Container>
       <RentHeader />


{/* Banner section start from here */}

      <section className='bannerSuccessMain_old'>
          <div className="row">
                <div className='col-lg-5'>
                    <div className='bannerSuccessLeft'>
                    <img alt="Rent Success | Rentid" src={rent_success}></img>
                    <small>CUSTOMER AND TECHNICAL SUPPORT</small>
                    <h1 className="successDesktop"><span>Live & automated</span> rental support when needed</h1>
                    <h1 className="successMobile"><span>Live &</span><span> automated</span> rental support when needed</h1>
                      <p>The <span>rentid</span> support team for you and your guests. We’re always available via chat, text, phone, or email, 
                      and powered by humans or robots for quicker service.</p>
                    </div>
                </div>

                <div className='col-lg-7'>
                    <div className='bannerSuccessRight'>
                      {/* <img src={success_purple} alt=''/> */}
                      <Rentsuccessanimation />
                    </div>
                </div>
          </div>
      </section>
        
        </Container>
      </div>
 
      <RentSuccessPage/>
 
      {/* <PopularTopics/>  */}
      <Footer/>
      <BetaForm/>
  </>
  )
}

export default RentSuccess2
